import React, { useContext } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Tooltip } from "@mui/material";

import GlobalContext from "../GlobalContext";

export default function SuperAppButton({
  children,
  showSpinner,
  loading,
  ...props
}) {
  const superAppStyle = useContext(GlobalContext)["superAppStyle"];

  // eslint-disable-next-line no-lone-blocks
  {
    /* return <Button style={superAppStyle.btnPrimary} props={...props} ></Button>; */
  }
  const customStyles = superAppStyle.btnPrimary;
  const hoverToolTip = props.hover_tool_tip;
  const disabled = props.disabled || false;
  return (
    <Tooltip title={hoverToolTip} placement="top">
      <span>
        <Button
          style={{ ...customStyles, ...props.style }}
          {...props}
          disabled={disabled || loading}
        >
          {children}
          {showSpinner && loading && (
            <Spinner
              animation="border"
              size="sm"
              // style={{ marginRight: "5px" }}
            />
          )}
        </Button>
      </span>
    </Tooltip>
  );
}
/*
    <Button style={{ ...customStyles, ...props.style }} {...props}>
*/
